import MapDraw from 'map/MapDraw';
import { TenantWithPointId } from 'types/common/tenant.type';
import { focusToPoi } from './camera';
import { clearMap } from './common/clear';
import { drawMarkers } from './marker';
import { findPoi } from './poi';

// 편의시설 마커
export const drawFacilityMarkers = async (tenants: TenantWithPointId[], currentFloorId: string) => {
  clearMap();

  // TODO: marker type
  const tenantMarkers: any = tenants.map((tenant: TenantWithPointId) => {
    // object id가 있다면
    if (tenant.content.objectId) {
      const object = MapDraw.mapData.dataObject.find({ id: tenant.content.objectId });
      if (object) {
        return {
          x: Number(object.position.x),
          y: Number(object.position.y),
          iconOption: {
            positionZ: 50,
            iconUrl: '/assets/icon/arrive.png',
            width: 50,
            height: 70,
            anchor: {
              x: 0.5,
              y: -0.1,
            },
          },
          floorId: tenant.content.floorId,
          // poiId: tenant.content.poiId,
          // 숨겨진 POI를 카메라에서 사용하다 보니 오류 발생 그래서 주석
        };
      }

      return;
    }

    // poi Id 로 poi position find
    const poi = findPoi({
      id: tenant.content.poiId,
    });

    let position;

    if (poi) {
      if (!Array.isArray(poi)) {
        position = poi.position;
      } else {
        position = poi[0].position;
      }
    }

    return {
      x: Number(position?.x),
      y: Number(position?.y),
      iconOption: {
        positionZ: 50,
        iconUrl: '/assets/icon/arrive.png',
        width: 50,
        height: 70,
        anchor: {
          x: 0.5,
          y: -0.1,
        },
      },
      floorId: tenant.content.floorId,
      // poiId: tenant.content.poiId,
      // 숨겨진 POI를 카메라에서 사용하다 보니 오류 발생 그래서 주석
    };
  });

  // 현재 층의 편의시설
  const currentFloorMarkers = tenantMarkers.filter((marker: any) => marker.floorId === currentFloorId);
  // 제일 가까운 층의 편의시설
  const nearestFloorMarker = tenantMarkers.find((marker: any) => marker.floorId !== currentFloorId);

  if (currentFloorMarkers.length > 0) {
    focusToPoi(currentFloorMarkers);
    await drawMarkers(currentFloorMarkers);
  }

  return {
    currentFloorMarkers,
    nearestFloorMarker,
  };
};
